import { useEffect, useState } from 'react'

import { useWallet } from '@solana/wallet-adapter-react'
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui'

import solanaLogo from '@src/assets/chains/solana.svg'

export const SolanaWalletButton = () => {
    const { wallet, connected, publicKey, disconnect } = useWallet()
    const [buttonText, setButtonText] = useState('Solana')
    const [showDisconnect, setShowDisconnect] = useState(false)

    useEffect(() => {
        if (connected && wallet) {
            if (publicKey) {
                const address = publicKey.toString()
                const shortAddress = `${address.slice(0, 4)}...${address.slice(-4)}`
                setButtonText(shortAddress)
            } else {
                setButtonText(wallet.adapter.name)
            }
        } else {
            setButtonText('Solana')
        }
    }, [wallet, connected, publicKey])

    const handleDisconnect = (e: React.MouseEvent) => {
        e.stopPropagation() // Prevent the click from triggering the wallet modal
        disconnect()
        setShowDisconnect(false)
    }

    return (
        <div className='relative'>
            <WalletMultiButton
                className='custom-wallet-button'
                onClick={() => connected && setShowDisconnect(prev => !prev)}
            >
                {!publicKey && <img src={solanaLogo} alt='Solana' className='h-7 w-7 rounded-2xl' />}
                {buttonText}
            </WalletMultiButton>

            {/* Disconnect dropdown */}
            {connected && showDisconnect && (
                <div
                    className='absolute right-0 top-full z-50 mt-2 min-w-[160px] rounded-lg bg-[#1A1B1F] py-2 shadow-lg'
                    onMouseLeave={() => setShowDisconnect(false)}
                >
                    <button
                        onClick={handleDisconnect}
                        className='w-full px-4 py-2 text-left text-white transition-colors hover:bg-[#2A2C31]'
                    >
                        Disconnect
                    </button>
                </div>
            )}
        </div>
    )
}
